import { render, staticRenderFns } from "./CalendarEventsV4.vue?vue&type=template&id=25d760e8&scoped=true"
import script from "./CalendarEventsV4.vue?vue&type=script&lang=js"
export * from "./CalendarEventsV4.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventsV4.vue?vue&type=style&index=0&id=25d760e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d760e8",
  null
  
)

export default component.exports